<template>
  <div class="send-cv-modal">
    <transition name="opacity">
      <div class="cover" @click="cancel"></div>
    </transition>
    <transition name="box">
      <div class="box">
        <div class="message-header">
          <span style="font-weight: bold">发送简历至邮箱</span>
          <div class="message-sub-header">
            输入您的邮箱地址，简历将以PDF格式发送至您的邮箱
          </div>
        </div>
        <div class="message-content">
          <div style='font-size: 12px; margin-bottom: 10px; line-height: 12px;'>邮箱账号</div>
          <input type="text" v-model="email" placeholder="请输入您的邮箱账户" v-on:input="inputEmail">
          <div class='err-msg' v-if='showErrMsg'>
            <i class='iconfont iconcuowu'></i>
            <span>{{errorMsg}}</span>
          </div>
        </div>
        <div class='cv-detail'>
          <img src="https://files.wondercv.com/pdf%402x.png" alt="" class="cv-detail-img">
          <div class="cv-name">{{name}}</div>
        </div>
        <div class="message-btn">
          <button class="cancel" @click="cancel">取消</button>
          <button class="action gray" @click="fakeConfirm" v-if='grayConfirm'>发送</button>
          <button class="action" @click="confirm" v-else>发送</button>
        </div>
        <pay-alert
          v-if="payAlertState"
          :active-pic="active"
          displayContinueBtn
          continueBtnText="继续发送"
          @close="payAlertState = false"
          @downloadContinue="sendEmail"
        />
      </div>
    </transition>
  </div>
</template>
<script>
  import {mapState} from 'vuex';
  import api from '@/api';
  import payAlert from '../../views/account/user/payAlert.vue'
  import { FOREVER_PRICE } from '../../assets/js/const'
  export default {
    name: 'message',
    components: {
      payAlert
    },
    data() {
      return {
        grayConfirm: true,
        showErrMsg: false,
        errorMsg: '请输入正确的邮箱地址',
        name: '',
        token: '',
        email: '',
        active: FOREVER_PRICE,
        payAlertState: false
      };
    },
    props: {
      cvToken: {
        type: String,
        default: ''
      },
      cvName: {
        type: String,
        default: ''
      },
      profile: {
        type: Object,
        default: {}
      }
    },
    created(){
      this.name = this.cvName
      this.token = this.cvToken

      if(this.profile.email){
        this.email = this.profile.email
        // 检查邮箱状态
        this.inputEmail()
      }
    },
    computed: {
      ...mapState("me", ["personInfo"]),
      isMember() {
        return this.personInfo.is_membership
      }
    },
    methods: {
      inputEmail(){
        if(this.email == ''){
          this.grayConfirm = true
          this.showErrMsg = false
        }else{
          this.grayConfirm = false
        }
      },
      close() {
        this.$emit('sendCv', '')
      },
      cancel() {
        this.$emit('sendCv', '')
      },
      fakeConfirm() {},
      async confirm() {
        try {
          const params = {
            origin: "pc",
          };
          const { code, data } = await api.account.checkUseVip(this.token, params);
          if (code === 1000 && !data?.use_vip && !this.isMember) {
            this.payAlertState = true;
          } else {
            this.sendEmail()
          }
        } catch (error) {
          console.log(error);
        }
      },
      async sendEmail () {
        let emailExp = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i
        if (!emailExp.test(this.email)) {
          this.showErrMsg = true
          return
        }
        let params = {
          showProfile: true,
          origin: 'pc'
        }
        let res = await api.cvsEditor.sendCvEmail(this.token, this.email, params)
        if (res.code === 1000) {
          this.close()
          this.showErrMsg = false
          this.$message.success('发送成功');
        } else if (res.code === 80160){
          // 会员阻断
          this.$store.dispatch('app/setAlertData', {
            show: true,
            type: 'upVip'
          })
          return false
        } else{
          this.$message.error('发送失败，请重试');
        }
      },
    }
  }
</script>
<style lang="scss" scoped>
  @import '~/assets/css/variable';
  .send-cv-modal {
    width: 0;
    height: 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    .cover {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
    }
    .box {
      width: 446px;
      height: 341px;
      background: #fff;
      border-radius: 4px;
      position: absolute;
      top: 30%;
      .message-close {
        font-size: 20px;
        color: #404040;
        font-weight: 600;
        float: right;
        cursor: pointer;
      }
      .message-header {
        height: fit-content;
        // border-bottom: 1px solid #E8E8E8;
        font-size: 18px;
        font-weight: 600;
        color: #404040;
        // line-height: 72px;
        padding: 28px 32px 26px 32px;
        .message-sub-header {
          font-weight: normal;
          color: #909090;
          font-size: 14px;
          margin-top: 12px;
        }
      }
      .cv-detail{
        height: 26px;
        border-radius: 4px;
        display: flex;
        background: #f9f9f9;
        padding: 12px 16px;
        align-items: center;
        width: 358px;
        margin: 10px auto;
        img{
          width: 20px;
          margin-right: 8px;
        }
        .cv-name{
          max-width: 266px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .message-content {
        line-height: 24px;
        padding: 0 32px;
        font-size: 14px;
        color: #606060;
        .err-msg{
          display: flex;
          align-items: center;
          color: #ff4f4c;
          margin-top: 10px;
          line-height: 14px;
          i{
            margin-right: 8px;
          }
        }
        input{
          height: 36px;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
          background: transparent;
          padding: 0 12px;
          width: 358px;
          color: #404040;
        }
      }
      .message-btn {
        display: flex;
        justify-content: flex-end;
        position: absolute;
        right: 32px;
        bottom: 32px;
        button {
          display: block;
          width: 84px;
          height: 36px;
          border: 1px solid #D9D9D9;
          border-radius: 2px;
          font-size: 14px;
          color: #606060;
          background: #fff;
          &.action {
            background: #FF4F4C;
            border-color: #FF4F4C;
            color: #fff;
          }
          &.action.gray {
            background: #cfcfcf;
            border-color: #cfcfcf;
            cursor: not-allowed;
          }
          &.cancel.seccess{
            border-color: #FF4F4C;
            color: #FF4F4C;
          }
          &:last-child {
            margin-left: 16px;
          }
        }
      }
    }
  }
</style>
